import { QueryClient } from '@tanstack/react-query';

/**
 * Single shared TanStack Query client. The defaults below are tuned for a
 * data-heavy productivity app rather than a content-heavy site:
 *   - Don't refetch on window focus by default (warehouse staff alt-tab a lot).
 *   - Retry once on transient errors; don't retry on 4xx.
 *   - 30s stale window so quick navigation reuses cached data.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        const status = (error as { status?: number }).status;
        if (status !== undefined && status >= 400 && status < 500) return false;
        return failureCount < 1;
      },
    },
    mutations: {
      retry: false,
    },
  },
});
